var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconScheduleHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004FFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Calendar_545370",
    transform: "translate(-8.6 -13.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    className: "st0",
    d: "M33.5999985,16.3999996h-20c-1.9720411,0.0043983-3.5696011,1.6019592-3.5739994,3.5740013 v16.8519993c0.0043983,1.9720421,1.6019583,3.569603,3.5739994,3.5740013h20 c1.9720421-0.0043983,3.569603-1.6019592,3.5740013-3.5740013V19.9740009 C37.1696014,18.0019588,35.5720406,16.404398,33.5999985,16.3999996z M13.5999994,18.2999992h20 c0.9218292,0.0038338,1.6681671,0.7501736,1.6720009,1.6720009v3.1800003H11.9259996v-3.1800003 C11.929842,19.0493965,12.677392,18.3027401,13.5999994,18.2999992z M33.5999985,38.5h-20 c-0.9233847-0.0027466-1.6712542-0.7506142-1.6739998-1.6739998V25.0890007h23.3460007v11.7369995 C35.2692604,37.7486076,34.5226021,38.4961586,33.5999985,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    className: "st0",
    d: "M18.6159992,28.203001h-3.5080004 c-0.5246716-0.0240707-0.9695129,0.3817482-0.9935837,0.9064178s0.3817463,0.9695129,0.9064178,0.9935837 c0.0290394,0.0013313,0.0581264,0.0013313,0.0871658,0h3.5079985c0.5246716,0.0240707,0.9695129-0.3817482,0.9935837-0.9064178 s-0.3817463-0.9695129-0.9064178-0.9935837C18.6741238,28.2016697,18.6450367,28.2016697,18.6159992,28.203001z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    className: "st0",
    d: "M18.6159992,32.6290016h-3.5080004 c-0.5246716-0.0240707-0.9695129,0.3817482-0.9935837,0.9064178c-0.0240707,0.5246735,0.3817463,0.9695129,0.9064178,0.9935837 c0.0290394,0.0013351,0.0581264,0.0013351,0.0871658,0h3.5079985c0.5246716,0.0240707,0.9695129-0.3817444,0.9935837-0.9064178 c0.0240707-0.5246696-0.3817463-0.9695129-0.9064178-0.9935837C18.6741238,32.6276703,18.6450367,32.6276703,18.6159992,32.6290016 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    className: "st0",
    d: "M25.3700008,28.203001h-3.5410004c-0.5246696,0.0240707-0.9304886,0.468914-0.9064178,0.9935837 c0.0225258,0.4909668,0.415451,0.8838921,0.9064178,0.9064178h3.5079994c0.5252228,0,0.9510002-0.4257774,0.9510002-0.9510002l0,0 c0.0138168-0.5101242-0.3885193-0.934864-0.8986435-0.9486809C25.382906,28.203146,25.3764553,28.2030392,25.3700008,28.203001z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    className: "st0",
    d: "M25.3700008,32.6290016h-3.5410004 c-0.5246696,0.0240707-0.9304886,0.468914-0.9064178,0.9935837c0.0225258,0.4909668,0.415451,0.8838959,0.9064178,0.9064178 h3.5079994c0.5249939-0.0005493,0.9504509-0.4260025,0.9510002-0.9510002 c0.0138168-0.5101242-0.3885193-0.934864-0.8986435-0.9486809C25.382906,32.6291466,25.3764553,32.6290398,25.3700008,32.6290016z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    className: "st0",
    d: "M32.0920029,28.203001h-3.5080032 c-0.5246696-0.0240707-0.9695129,0.3817482-0.9935837,0.9064178s0.3817482,0.9695129,0.9064178,0.9935837 c0.0290413,0.0013313,0.0581245,0.0013313,0.0871658,0h3.5080032c0.5246735-0.0240707,0.9304886-0.468914,0.9064178-0.9935837 C32.9758987,28.6184521,32.5829697,28.2255268,32.0920029,28.203001z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    className: "st0",
    d: "M32.0920029,32.6290016h-3.5080032 c-0.5246696-0.0240707-0.9695129,0.3817482-0.9935837,0.9064178c-0.0240707,0.5246735,0.3817482,0.9695129,0.9064178,0.9935837 c0.0290413,0.0013351,0.0581245,0.0013351,0.0871658,0h3.5080032c0.5246735-0.0240707,0.9304886-0.4689102,0.9064178-0.9935837 C32.9758987,33.0444527,32.5829697,32.6515274,32.0920029,32.6290016z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_75",
    className: "st0",
    cx: 16.157999,
    cy: 20.6949997,
    rx: 1.443,
    ry: 1.443
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    className: "st0",
    cx: 31.0429993,
    cy: 20.6949997,
    rx: 1.443,
    ry: 1.443
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScheduleHeader);
export default __webpack_public_path__ + "static/media/icon_schedule_header.e070cc89a1187970f2afe05288e618e7.svg";
export { ForwardRef as ReactComponent };